module.exports = __webpack_public_path__ + "img/background.fa35ddc4.webp";